import { render, staticRenderFns } from "./Dna.vue?vue&type=template&id=0637edfa&"
import script from "./Dna.vue?vue&type=script&lang=js&"
export * from "./Dna.vue?vue&type=script&lang=js&"
import style0 from "./Dna.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports